export const clearInput = (target: EventTarget & HTMLInputElement) => {
  // eslint-disable-next-line no-param-reassign
  target.value = '';
};
